module.exports = __webpack_public_path__ + "img/Five.01cffe25.jpg";